<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h5 class="panel-title">
                <span class="title">Bem Vindo(a) {{ this.currentUser.usuario.nome }}</span>
              </h5>
            </div>
          </div>
        </div>
        <div id="topo" class="card-body">
          <h5 class="panel-title">
            <span class="title">Conceda acesso aos seus respectivos responsáveis.</span>
          </h5>
          <div class="row">
            <DataTable :value="usuarioAcessoList" :paginator="true" :rows="10" :autoLayout="true">
              <template #header>
                <div style="line-height:1.87em" class="p-clearfix">Lista de Usuários com acesso.</div>
              </template>
              <Column headerStyle="width: 8em" bodyStyle="text-align: center" header="Permissões">
                <template #body="slotProps">
                  <Button type="button" icon="pi pi-cog" @click="showPermissoes(slotProps.data.id)"></Button>
                </template>
              </Column>
              <Column headerStyle="width: 18em" bodyStyle="text-align: center" header="Retirar Permissão Master">
                <template #body="slotProps">
                  <Button type="button" icon="pi pi-remove" label="Retirar Permissão Master"
                    @click="saveUsuarioMasterFiscal(slotProps.data.id, 'N')"></Button>
                </template>
              </Column>
              <Column field="pessoa.numeroDocumentoJuridico" header="CPF"></Column>
              <Column field="nomeAcesso" header="Login"></Column>
              <Column field="pessoa.nomeGeral" header="Nome"></Column>
              <Column headerStyle="width: 18em" bodyStyle="text-align: center" header="Tipo"
                v-if="this.cadastroContador">
                <template #body="slotProps">
                  <span>{{ slotProps.data.idContribuinteVinculo ? 'Contador' : 'Usuário' }}</span>
                </template>
              </Column>
            </DataTable>
          </div>
          <hr />
        </div>
      </div>
    </div>

    <Dialog header="Aviso" :visible.sync="displayRemove" :style="{ width: '30vw' }" :modal="true">
      Confirma a remoção do Registro?
      <template #footer>
        <Button label="Sim" icon="pi pi-check" @click="remove" />
        <Button label="Não" icon="pi pi-times" @click="close" class="p-button-secondary" />
      </template>
    </Dialog>
    <Dialog header="Permissões" :visible.sync="showPerm" :style="{ width: '80vw' }" :modal="true" :closable="false">

      <div class="error-list">
        <Message :closable="false" severity="error" v-if="erros.length">
          <p class="mt-3">{{ erros.join(' ') }}</p>
        </Message>
      </div>
      <div class="row">
        <DataTable :value="perfilList" :paginator="true" :rows="10" :autoLayout="true">
          <Column field="idPagina.menuCompleto" header="Menu"></Column>
          <Column field="habilitarBol" header="Habilitar">
            <template #body="slotProps">
              <Checkbox v-model="slotProps.data.habilitarBol" :binary="true" />
            </template>
          </Column>
          <Column field="salvarBol" header="Salvar">
            <template #body="slotProps">
              <Checkbox v-model="slotProps.data.salvarBol" :binary="true" :disabled="!slotProps.data.salvarContr" />
            </template>
          </Column>
          <Column field="alterarBol" header="Alterar">
            <template #body="slotProps">
              <Checkbox v-model="slotProps.data.alterarBol" :binary="true" :disabled="!slotProps.data.alterarContr" />
            </template>
          </Column>
          <Column field="excluirBol" header="Excluir">
            <template #body="slotProps">
              <Checkbox v-model="slotProps.data.excluirBol" :binary="true" :disabled="!slotProps.data.excluirContr" />
            </template>
          </Column>
          <Column field="imprimirBol" header="Imprimir">
            <template #body="slotProps">
              <Checkbox v-model="slotProps.data.imprimirBol" :binary="true" :disabled="!slotProps.data.imprimirContr" />
            </template>
          </Column>
          <Column field="controlarCamposBol" header="Controlar Campos">
            <template #body="slotProps">
              <Button class="text-center" label="Controlar Campos" icon="pi pi-sliders-h"
                @click="openFieldDialog(slotProps.data)" />
            </template>
          </Column>
        </DataTable>

        <Dialog header="Controle de Campos" :visible.sync="fieldDialogVisible" :modal="true" :style="{ width: '50vw' }">
          <DataTable :value="currentFieldData" :paginator="true" :rows="6" :autoLayout="true">
            <Column field="nome" header="Nome do Campo"></Column>
            <Column header="Habilitar">
              <template #body="slotProps">
                <Checkbox v-model="slotProps.data.habilitar" :binary="true" />
              </template>
            </Column>
          </DataTable>
          <hr />
          <div class="container">
            <div class="row">
              <div>
                <Button label="Salvar" icon="pi pi-check" @click="saveFieldPermissions" />
              </div>

              <div>
                <Button label="Fechar" icon="pi pi-times" class="p-button-secondary" @click="closeFieldDialog" />
              </div>
            </div>
          </div>
        </Dialog>
      </div>

      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button @click="salvarPerm" label="Salvar" class="p-button-primary mr-2" icon="pi pi-check"
              :disabled="loading" />
            <Button @click="hidePerm" type="button" label="Fechar" class="p-button-primary mr-2 p-button-danger"
              icon="pi pi-times" />
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import PerfilAcessoUsuarioService from '../services/nfse/perfil.acesso.usuario.service';
import UsuarioAcessoService from '../services/nfse/usuario.acesso.service';
import LoginService from '../services/acesso/login.service';
import UsuarioService from '../services/acesso/usuario.service';
import Util from '../Utils/util';
import usuarioAcessoCampoService from '../services/nfse/usuario.acesso.campo.service';

export default {
  name: 'acessoFiscal',
  data() {
    return {
      showPerm: false,
      displayRemove: false,
      loading: false,
      erros: [],
      currentUser: null,
      search: false,
      filtro: '',
      usuarioAcessoList: [],
      usuarioAcessoId: null,
      idContribuinte: null,
      showCadastroNovoUsuario: false,
      blockDadosPessoa: false,
      blockDadosUsuario: false,
      perfilList: [],
      admin: false,
      senhaConfirmacao: null,
      cadastroContador: false,
      filtroTipo: null,
      filtroTipos: [
        { name: 'Usuário', key: 'U' },
        { name: 'Contador', key: 'C' },
      ],

      fieldDialogVisible: false,
      currentFieldData: [],
    };
  },
  created() {
    this.processando(true);
    this.currentUser = LoginService.currentUserValue;
    this.filtroTipo = this.filtroTipos[0];
    this.cadastroContador =
      this.currentUser.configuracao.idBolCadastroContador &&
      this.currentUser.configuracao.idBolCadastroContador === 'S';
    this.pesquisar();
    this.processando(false);
  },
  methods: {
    openFieldDialog(rowData) {
      if (rowData && rowData.idPagina) {
        const idPagina = rowData.idPagina.id;
        this.usuarioAcessoId = rowData.idUsuario;

        usuarioAcessoCampoService.buscarCamposPorPaginaEUsuario(idPagina, this.usuarioAcessoId).then(
          (result) => {
            console.log(result.data);
            this.currentFieldData = result.data.map((campo) => {
              const habilitar = campo.habilitar === 'S';
              console.log(`Campo: ${campo.nomeCampo}, Habilitar: ${habilitar}`);
              return {
                id: campo.campoId,
                nome: campo.nomeCampo,
                habilitar: habilitar,
                paginaCampoId: campo.paginaCampoId,
              };
            });
            this.fieldDialogVisible = true;
          },
          (error) => {
            const errorMessage = (error.response && error.response.data) || 'Houve um problema ao buscar os campos!';
            this.$toast.add({
              severity: 'error',
              summary: errorMessage,
            });
          },
        );
      }
    },

    closeFieldDialog() {
      this.fieldDialogVisible = false;
    },

    saveFieldPermissions() {
      const camposParaSalvar = this.currentFieldData.map((campo) => ({
        usuarioId: this.usuarioAcessoId,
        paginaCampoId: campo.paginaCampoId,
        habilitar: campo.habilitar ? 'S' : 'N',
      }));

      usuarioAcessoCampoService.salvarPermissoesCampos(camposParaSalvar).then(
        () => {
          this.$toast.add({
            severity: 'success',
            summary: 'Permissões de acesso aos campos salvas com sucesso!',
          });
          this.fieldDialogVisible = false;
        },
        (error) => {
          const errorMessage = (error.response && error.response.data) || 'Houve um problema ao salvar as permissões!';
          this.$toast.add({
            severity: 'error',
            summary: errorMessage,
          });
        },
      );
    },

    isEmailValid: function (email) {
      // eslint-disable-next-line
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    pesquisar() {

      this.search = true;
      UsuarioAcessoService.findAllUserAdmin(this.currentUser.usuario.idCliente).then((ua) => {
        this.usuarioAcessoList = ua.data;
        console.log(this.usuarioAcessoList);
      });
      this.search = false;
    },
    confirmRemove(usuarioAcessoId, idContribuinte) {
      this.usuarioAcessoId = usuarioAcessoId;
      this.idContribuinte = idContribuinte;
      this.displayRemove = true;
    },
    close() {
      this.usuarioAcessoId = null;
      this.displayRemove = false;
    },
    saveUsuarioMasterFiscal(idUsuario, master) {
      UsuarioService.salvarUsuarioMasterFiscal(
        idUsuario,
        master
      ).then(
        (data) => {
          console.log(data);
          this.$toast.add({
            severity: "success",
            summary: "Permissão Retirada!",
          });
          setTimeout(async () => {
            await this.pesquisar();
          }, 250);
        },
        (error) => {
          console.log(error);
          this.$root.$emit(
            "alert:error",
            "Houve um problema ao informar Permissão Master para o Registro!"
          );
        }
      );
    },
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit('loading:show');
      } else {
        this.loading = false;
        this.$root.$emit('loading:hide');
      }
    },
    searchUsuarioPorCpf() {
      const documento = this.usuarioCadastro.documento;

      if (documento && documento != '' && this.validarDocumento()) {
        this.processando(true);
        this.blockDadosPessoa = false;
        this.blockDadosUsuario = false;
        UsuarioService.getUsuarioByCpf(documento, this.currentUser.usuario.idCliente, this.currentUser.usuario.idConta)
          .then((data) => {
            // console.log(data);
            this.usuarioCadastro = data;
            if (data.idPessoa) {
              this.blockDadosPessoa = true;
            }
            if (data.idUsuario) {
              this.blockDadosUsuario = true;
            }
          })
          .then(() => {
            this.processando(false);
          });
      } else {
        this.processando(true);
      }
    },
    showPermissoes(idUsuario) {
      this.processando(true);
      this.usuarioAcessoId = idUsuario;
      this.pesquisarPerms();
      this.showPerm = true;
      this.processando(false);
    },
    hidePerm() {
      this.showPerm = false;
    },
    pesquisarPerms() {
      PerfilAcessoUsuarioService.findAllByUsuarioFisc(this.currentUser.usuario.idCliente, this.usuarioAcessoId).then(
        (perfil) => {
          this.perfilList = perfil.data;
          // console.log(this.usuarioAcessoId);
        },
        (error) => {
          let errorMessage = 'Houve um problema listar Perfis de Acesso do Usuário!';
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: 'error',
            summary: errorMessage,
          });
        },
      );
      this.search = false;
    },
    salvarPerm() {
      PerfilAcessoUsuarioService.saveFiscal(this.usuarioAcessoId, this.perfilList).then(
        (data) => {
          console.debug(data);
          this.$toast.add({
            severity: 'success',
            summary: 'Permissões de Acesso salvas com sucesso',
          });
        },
        (error) => {
          let errorMessage = 'Houve um problema ao salvar as Permissões de Acesso!';
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: 'error',
            summary: errorMessage,
          });
        },
      );
    },

    validarDocumento() {
      var validar = false;
      if (!this.usuarioCadastro.documento || this.usuarioCadastro.documento === '') {
        return false;
      }
      validar = Util.validarCPFCNPJ(this.usuarioCadastro.documento);

      if (!validar) {
        this.$root.$emit('alert:error', 'CPF/CNPJ inválido!');
      }
      return validar;
    },
  },
};
</script>

<style src="../assets/css/acessoFiscal.css"></style>
